import { render } from "./hero.vue?vue&type=template&id=70fd926b&ts=true"
import script from "./hero.vue?vue&type=script&lang=ts"
export * from "./hero.vue?vue&type=script&lang=ts"

import exportComponent from "/geosite/web/geosite-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__